var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as classNames from 'classnames';
import ListTeamsItemStatus from './ListTeamsItemStatus';
import ListTeamsItemSummated from './ListTeamsItemSummated';
import ListAthletesItem from './ListAthletesItem';
import AlertEmptyTeamPrompt from './AlertEmptyTeamPrompt';
var selfStyles = require('./styles.scss');
var ListTeamsItem = (function (_super) {
    __extends(ListTeamsItem, _super);
    function ListTeamsItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            prevRank: props.rank || 0,
            diffRank: 0,
            cssToggle: true,
        };
        return _this;
    }
    ListTeamsItem.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.rank &&
            nextProps.rank !== this.state.prevRank) {
            this.setState({
                prevRank: nextProps.rank,
                diffRank: nextProps.rank - (this.props.rank || 0),
                cssToggle: !this.state.cssToggle,
            });
        }
        else if (nextProps.teamScore &&
            this.props.teamScore &&
            nextProps.teamScore.updatedAt !== this.props.teamScore.updatedAt) {
            this.setState({
                prevRank: nextProps.rank || 0,
                diffRank: 0,
            });
        }
    };
    ListTeamsItem.prototype.render = function () {
        var _this = this;
        var isGravicalTeamHack = this.props.round.eventId === 'ba322ae2-9b71-4bcc-af2b-70f328c70b2c' || this.props.round.eventId === 'cfa03e10-92b1-4e3d-b32c-45299cbbf092';
        return (React.createElement("div", { className: classNames(selfStyles.teamItem, (_a = {}, _a[selfStyles.teamItemActive] = this.props.isActive, _a)) },
            React.createElement("div", { className: selfStyles.teamItemHeader, onClick: this.props.handleClickTeamItem },
                React.createElement("div", { className: selfStyles.athleteItemInfoLeft },
                    React.createElement("span", { className: selfStyles.athleteRankPrefix },
                        React.createElement("span", { className: classNames(selfStyles.athleteRankArrow, (_b = {},
                                _b[selfStyles.athleteRankArrowUp] = this.state.diffRank < 0,
                                _b[selfStyles.athleteRankArrowDown] = this.state.diffRank > 0,
                                _b[selfStyles.athleteRankArrowFadeOne] = this.state.cssToggle,
                                _b[selfStyles.athleteRankArrowFadeTwo] = !this.state.cssToggle,
                                _b)) }),
                        "#"),
                    React.createElement("span", { className: selfStyles.athleteRank }, !!this.props.rank ? this.props.rank : '?')),
                React.createElement("div", { className: selfStyles.athleteItemInfoCenter },
                    React.createElement("span", { className: selfStyles.athleteName }, this.props.team.name)),
                React.createElement("div", { className: selfStyles.athleteItemInfoRight },
                    React.createElement(ListTeamsItemStatus, { isActive: this.props.isActive, teamScore: this.props.teamScore }),
                    React.createElement(ListTeamsItemSummated, { scoreSystemKey: this.props.round.scoreSystem, teamScore: this.props.teamScore }))),
            React.createElement("div", { className: selfStyles.teamItemRow },
                this.props.athletes.length === 0 &&
                    React.createElement(AlertEmptyTeamPrompt, null),
                this.props.athletes
                    .sort(function (a, b) { return (!!a.score && !!b.score) ? a.score.bibNumber - b.score.bibNumber : a.athlete.name.localeCompare(b.athlete.name); })
                    .map(function (as, index) { return (React.createElement(ListAthletesItem, { key: as.athlete.id, isActive: _this.props.isActiveAthlete === as.athlete.id, isPlatform: _this.props.isPlatform, isTeam: true, hideRank: true, hideAthleteScoreRoute: isGravicalTeamHack && index !== _this.props.athletes.length - 1, bibNumber: as.score ? as.score.bibNumber : 0, round: _this.props.round, athlete: as.athlete, athleteScore: _this.props.isPlatform || _this.props.round.isScoresVisible ? as.score : undefined, athleteScoreRoutes: _this.props.isPlatform || _this.props.round.isScoresVisible ? as.athleteScoreRoutes : undefined, athleteScoreRouteItemWidth: _this.props.athleteScoreRouteItemWidth, handleClickAthleteItem: function () { return _this.props.handleClickAthleteItem(as); }, handleChangeAthleteScoreRoute: _this.props.handleChangeAthleteScoreRoute })); }))));
        var _a, _b;
    };
    return ListTeamsItem;
}(React.Component));
export default ListTeamsItem;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListTeamsItem.tsx
// module id = 662
// module chunks = 0